(function() {
  window.logService = {
    save(data) {
      return axios.post('/api/log/save.php', data);
    }
  }
})();